export default __webpack_public_path__ + "static/media/CHANTAL.891f4da9.png";